import { computed } from 'vue';
import { getSanitizedNavigationQueryAndHash } from '@pkg/utilities/urls/sanitizeNavigationQuery';

type PublicWithParamsAllowList = { paramsAllowList?: string };

/**
 * {@link getSanitizedNavigationQueryAndHash} for the current route, using
 * `useRuntimeConfig().public.paramsAllowList` (from NUXT_PUBLIC_ALLOW_LIST / runtime config).
 */
export function useSanitizedNavigationFromRoute() {
  const route = useRoute();
  const runtimeConfig = useRuntimeConfig();

  const getSanitizedQueryAndHash = () =>
    getSanitizedNavigationQueryAndHash(
      route.query,
      route.hash,
      (runtimeConfig.public as PublicWithParamsAllowList).paramsAllowList,
    );

  const sanitizedQueryAndHash = computed(getSanitizedQueryAndHash);

  return {
    getSanitizedQueryAndHash,
    sanitizedQueryAndHash,
  };
}
